import React, { useState } from 'react'
import styles from './styles.module.css'

function Taxonomy ({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  const taxonomyLevels = Object.keys(record)
    .filter(key => key.startsWith('taxonomyLevel'))
    .sort()
    .map(key => record[key])

  const levelsToShow = isExpanded ? taxonomyLevels : taxonomyLevels.slice(0, 3)

  return (
    <div className={styles.taxonomyLevelContainer}>
      <h1 className={styles.taxonomyLevelTitle}>Taxonomy</h1>

      <div className={styles.taxonomyLevelList}>
        {levelsToShow.length > 0 ? (
          levelsToShow.map((level, index) => (
            <span key={index} className={styles.taxonomyLevelItem}>
              {level || 'N/A'}
            </span>
          ))
        ) : (
          <span className={styles.noTaxonomyLevel}>N/A</span>
        )}
      </div>

      {taxonomyLevels.length > 3 && (
        <button className={styles.taxonomyLevelButton} onClick={toggleExpand}>
          {isExpanded
            ? 'Show less'
            : `Expand all (${taxonomyLevels.length})`}
        </button>
      )}
    </div>
  )
}

export default Taxonomy
